import { Waypoint } from '@porterin/booking-flow/src/order-review/domain/entities/Waypoint';
import { OrderReviewAssets } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewStore';
import NextImage from 'next/image';

export interface WaypointIconProps {
  waypoint: Waypoint;
  height?: number;
  width?: number;
}

const WaypointIcon: React.FC<WaypointIconProps> = ({
  waypoint,
  height = 15,
  width = 12,
}) => {
  return waypoint === 'Pickup' ? (
    <div
      id="pickup-waypoint"
      className="w-[1rem] h-[1rem] bg-[#0E8155] rounded-full"
    />
  ) : (
    <NextImage
      height={height}
      width={width}
      src={OrderReviewAssets.dropIcon.src}
      alt={OrderReviewAssets.dropIcon.alt}
      quality={70}
      id="drop-waypoint"
    />
  );
};

export default WaypointIcon;
